import React, { useEffect, useState } from "react";
import { Box, Typography, Paper, Grid } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { galleryActions } from "../actions";
import { makeRequest } from "../apis/makeRequest";
import { getCustomer, getTipologias } from "../apis/backendRequests";

const styles = {
  subCategoryContainer: {
    cursor: "pointer",
    transition: "transform 0.2s ease-in-out",
    "&:hover": {
      transform: "scale(1.05)",
      boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.3)",
    },
    padding: "24px",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    backgroundColor: "#f5f5f5",
    borderRadius: "8px",
    border: "1px solid #e0e0e0",
    minHeight: "150px",
  },
  label: {
    fontSize: "25px",
    textAlign: "center",
    textTransform: "uppercase",
    color: "#333",
    fontStyle: "italic"
  },
  iconBox: {
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    backgroundColor: "#1976d2",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "8px",
  },
  iconText: {
    color: "#fff",
    fontWeight: "bold",
    fontSize: "24px",
  },
};

const categorias = {
  Escritura: {
    color: "#812991",
    textColor: "white"
  },
  Escolar: {
    color: "#F7AC2D",
    textColor: "black"

  },
  Papeles: {
    color: "#D8E6AB",
    textColor: "black"

  },
  "Dibujo técnico": {
    color: "#0162B1",
    textColor: "white"

  },
  "Oficina": {
    color: "#DE421C",
    textColor: "white"

  }
};


const RubroCatalogo = () => {
  const { id } = useParams()
  const { dynamicsId, isLoggedIn } = useSelector((state) => state.account);
  const { brand } = useSelector((state) => state.gallery);

  const [dataCategories, setDataCategories] = useState([]);
  const [tabs, setTabs] = useState({ nameTabs: [], categories: [] });

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const allStr = 'Todas'
  useEffect(() => {
    makeRequest(
      () => getCustomer(isLoggedIn ? dynamicsId : "online"),
      (res) => {
        if (res.data.priceLevel) {
          makeRequest(
            () => getTipologias(res.data.priceLevel),
            (request) => { Object.keys(request.data).length > 0 && setDataCategories([{ name: allStr }, ...request.data]) },
            null,
            { checkEmptyResults: false }
          );
        }
      }
    );
  }, [brand, dynamicsId, isLoggedIn]);

  useEffect(() => {
    if (Object.keys(dataCategories).length !== 0) {
      const tab = dataCategories.reduce((ac, categoria) => {
        if (typeof categoria.categoriaDescription !== "undefined") {
          const tipo = categoria.categoriaDescription;
          if (!ac.hasOwnProperty(tipo)) {
            ac[tipo] = {};
          }
          const rubro = categoria.rubroDescription;

          if (!ac[tipo].hasOwnProperty(rubro)) {
            ac[tipo][rubro] = [];
          }
          ac[tipo][rubro].push(categoria);
        }
        return ac;
      }, {});

      setTabs({ categories: tab });
    }
  }, [dataCategories]);

  const handleNavigate = (rubro) => {
    dispatch(galleryActions.setSearchTerm(""));
    dispatch(galleryActions.setCategoria(id));
    dispatch(galleryActions.setRubro(rubro));
    dispatch(galleryActions.setSubRubro(""));
    dispatch(galleryActions.setPromocion(""));
    navigate(isLoggedIn ? "/products" : "/catalogo");
  };

  if (Object.keys(tabs.categories).length !== 0 && Object.keys(tabs).length !== 0 && tabs.categories[id])
    return (
      <Box>
        <Typography variant="h4" sx={{ mb: 3, textAlign: "center", ...styles.label }}>
          {id}
        </Typography>
        <Grid container spacing={3} sx={{ display: "flex", justifyContent: "center", flexWrap: "wrap", padding: "10px" }}>
          {Object.keys(tabs?.categories[id]).map((i, index) => (
            <Grid item xs={12} sm={6} md={4} key={`${i}-${index}`}>
              <Paper
                sx={{ ...styles.subCategoryContainer, backgroundColor: categorias[id].color }}
                variant={"outlined"}
                onClick={() => handleNavigate(i)}
              >
                <Typography sx={{ ...styles.label, color: categorias[id].textColor }}>{i}</Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Box >
    );
};

export default RubroCatalogo;
